import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "med-warship-banner",
  templateUrl: "./med-warship-banner.component.html",
  styleUrls: ["./med-warship-banner.component.scss"],
})
export class MedWarshipBannerComponent {
  @Input() linkBanner?: string;

  @Output() close = new EventEmitter<void>();

  linkClick() {
    window.open(this.linkBanner, "_blank");
  }
}
